// @flow
import React from "react";
import { useTranslation } from "react-i18next";

import Styles from "./Benefits.module.scss";

type Props = {
  categoryType: ?string,
};

const Benefits = ({ categoryType }: Props) => {
  const { t } = useTranslation("offerPageDetail");
  const categoryName = categoryType ? `${t(`categories:${categoryType}`)}` : "";

  return (
    <div className={Styles.benefits}>
      <div className={Styles.widthLimit}>
        <div className={Styles.responsiveContent}>
          <h2>{t("benefits.title")}</h2>
          <ol className={Styles.list}>
            {t("benefits.list", { categoryName, returnObjects: true }).map((benefit, i) => {
              return (
                <li key={i} className="theme-color-primary theme-border-color-primary">
                  <span>{benefit}</span>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
